import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';

import { LoaderComponent } from './components/loader/loader.component';
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';
import { SidemenuComponent } from './components/sidemenu/sidemenu.component';
import { NgbDatepicker, NgbModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { NotificationSidebarComponent } from './components/notification-sidebar/notification-sidebar.component';

import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { FullscreenToggleDirective } from './directives/fullscreen-toggle.directive';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { CustomizerComponent } from './components/customizer/customizer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateAsAgoPipe } from './pipes/date-as-ago.pipe';
import { HeaderComponent } from './components/header/header.component';
import { ImageUrlPipe } from './pipes/image-url.pipe';
import { ImageUrlAsyncPipe } from './pipes/image-url-async.pipe';
import { ImageSrcDirective } from './directives/image-src.directive';
import { DateAsUpcoming } from './pipes/date-as-upcoming';
import { SidebarModule } from 'primeng/sidebar';
import { PaginatorModule } from 'primeng/paginator';
import { BugReportsReasonPipe } from './pipes/bug-reports-reason.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { AdStatusPipe } from './pipes/ad-status.pipe';
import { DecimalFormatPipe } from './pipes/decimal-format.pipe';
import { UserStatusPipe } from './pipes/user-status.pipe';
import { DropzoneConfigInterface, DropzoneModule, DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TransactionTypePipe } from './pipes/transaction-type.pipe';
import { ArchwizardModule } from 'angular-archwizard';
import { PackageStatusPipe } from './pipes/package-status.pipe';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FilenamePipe } from './pipes/filename-pipe';
import { PaymentStatusPipe } from './pipes/payment-status.pipe';
import { ShortenMessagePipe } from './pipes/shorten-message.pipe';
import { ShortenTitlePipe } from './pipes/shorten-title.pipe';
import { PaymentTypePipe } from './pipes/payment-type';
import { ToastContainerComponent } from '../components/elements/toast/toast-container/toast-container.component';
import { ToastComponent } from '../components/elements/toast/toast.component';
import { ProviderStatusPipe } from './pipes/provider-status.pipe';
import { OpportunityCardComponent } from './components/opportunity-card/opportunity-card.component';
import { ApplicantStatusPipe } from './pipes/applicant-status.pipe';
import { AnswerStatusPipe } from './pipes/answer-type.pipe';
import { AdCardComponent } from './components/ad-card/ad-card.component';
import { MajorPipe } from './pipes/major.pipe';
import { ApplicationtypePipe } from './pipes/applicationtype.pipe';
import { CategoryPipe } from './pipes/opportunity.category.pipe';
import { GenderPipe } from './pipes/gender.pipe';
import { CityPipe } from './pipes/city.pipe';
import { StudentStatusPipe } from './pipes/student.status.pipe';
import { CollegePipe } from './pipes/college.pipe';
import { LanguagePipe } from './pipes/language.pipe';
import { ProficiencyPipe } from './pipes/proficiency.pipe';
import { ExperienceLevelPipe } from './pipes/exp-level.pipe';
import { SlotStatusPipe } from './pipes/slot-status.pipe';
import { CvStatusPipe } from './pipes/cv-status.pipe';
import { CvTemplateComponent } from './components/cv-template/cv-template.component';
import { WorkshopCvModalComponent } from './components/workshop-cv-modal/workshop-cv-modal.component';
import { LinkedinHandlePipe } from './pipes/linkedin-handle.pipe';
import { SubscriptionStatusPipe } from './pipes/subscription-status.pipe';
import { DegreeTypePipe } from './pipes/degree.type.pipe';
import { ExperienceTypePipe } from './pipes/experience.type.pipe';
import { GpaSystemPipe } from './pipes/gpa.system.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { HasRichTextPipe, RichTextPipe } from './pipes/rich-text.pipe';


const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // Change this to your upload POST address:
  url: 'https://httpbin.org/post',
  maxFilesize: 50,
  acceptedFiles: 'image/*'
};

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    LoaderComponent,
    TapToTopComponent,
    SidemenuComponent,
    NotificationSidebarComponent,
    FullLayoutComponent,
    FullscreenToggleDirective,
    HasPermissionDirective,
    CustomizerComponent,
    DateAsAgoPipe,
    ImageUrlPipe,
    ImageUrlAsyncPipe,
    ImageSrcDirective,
    DateAsUpcoming,
    BugReportsReasonPipe,
    FileSizePipe,
    AdStatusPipe,
    DecimalFormatPipe,
    UserStatusPipe,
    ToastComponent,
    ToastContainerComponent,
    TransactionTypePipe,
    PackageStatusPipe,
    FilenamePipe,
    PaymentStatusPipe,
    ShortenMessagePipe,
    ShortenTitlePipe,
    PaymentTypePipe,
    ApplicationtypePipe,
    ProviderStatusPipe,
    CategoryPipe,
    MajorPipe,
    OpportunityCardComponent,
    ApplicantStatusPipe,
    AnswerStatusPipe,
    AdCardComponent,
    GenderPipe,
    CityPipe,
    StudentStatusPipe,
    CollegePipe,
    LanguagePipe,
    ProficiencyPipe,
    ExperienceLevelPipe,
    SlotStatusPipe,
    CvStatusPipe,
    CvTemplateComponent,
    WorkshopCvModalComponent,
    LinkedinHandlePipe,
    SubscriptionStatusPipe,
    DegreeTypePipe,
    ExperienceTypePipe,
    GpaSystemPipe,
    RichTextPipe,
    HasRichTextPipe,
  ],

  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    DropzoneModule,
    NgxDropzoneModule,
    NgbPaginationModule,
    // ColorPickerModule,
    NgxIntlTelInputModule,
    NgxDatatableModule,
    NgSelectModule,
    ArchwizardModule,
    InfiniteScrollModule,
    CKEditorModule
  ],

  exports: [
    PaginatorModule,
    FormsModule,
    ReactiveFormsModule,
    SidebarModule,
    DateAsUpcoming,
    LoaderComponent,
    TapToTopComponent,
    FooterComponent,
    FullLayoutComponent,
    ImageUrlPipe,
    ImageUrlAsyncPipe,
    ImageSrcDirective,
    HasPermissionDirective,
    BugReportsReasonPipe,
    DateAsAgoPipe,
    FileSizePipe,
    AdStatusPipe,
    DecimalFormatPipe,
    UserStatusPipe,
    // ColorPickerModule,
    DropzoneModule,
    NgbDatepicker,
    NgxIntlTelInputModule,
    CurrencyPipe,
    NgxDatatableModule,
    ToastComponent,
    ToastContainerComponent,
    TransactionTypePipe,
    NgSelectModule,
    ArchwizardModule,
    PackageStatusPipe,
    InfiniteScrollModule,
    FilenamePipe,
    PaymentStatusPipe,
    ShortenMessagePipe,
    ShortenTitlePipe,
    PaymentTypePipe,
    ApplicationtypePipe,
    ProviderStatusPipe,
    CategoryPipe,
    MajorPipe,
    OpportunityCardComponent,
    ApplicantStatusPipe,
    AnswerStatusPipe,
    AdCardComponent,
    GenderPipe,
    CityPipe,
    StudentStatusPipe,
    CollegePipe,
    DegreeTypePipe,
    ExperienceTypePipe,
    GpaSystemPipe,
    LanguagePipe,
    ProficiencyPipe,
    ExperienceLevelPipe,
    SlotStatusPipe,
    CvStatusPipe,
    CvTemplateComponent,
    WorkshopCvModalComponent,
    LinkedinHandlePipe,
    SubscriptionStatusPipe,
    CKEditorModule,
    RichTextPipe,
    HasRichTextPipe

  ],
  providers: [
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    },
    ConfirmationModalComponent
  ]
})
export class SharedModule { }
